<!-- <div class="row">
    <div class="col-md-4">
    </div>

    <div class="col-md-4">
        <div class="card">
            <div class="card-header">Reset Your Password</div>
            <div class="card-body">
                <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit(resetPasswordForm)">
                    <div class="form-group">
                        <input type="password" name="password" class="form-control" placeholder="New Password" formControlName="password">
                    </div>

                    <input type="password" name="passwordConfirmation" class="form-control" placeholder="Confirm New Password" formControlName="passwordConfirmation">


                    <input type="submit" name="submit" class="btn btn-block btn-primary" value="Submit" [disabled]="!resetPasswordForm.valid">

                </form>
            </div>
        </div>
    </div>
</div> -->
<div class="primary full-page-height display-flex-lg">
    <div class="forgot-dialog">
        <div class="col-md-12">
            <div class="form custom-form">
                <h6>Create Your Password</h6>
                <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit(resetPasswordForm)">
                    <label class="mt-2">New Password</label>
                    <input type="password" name="password" formControlName="password" (keydown.space)="$event.preventDefault();" required>
                    <label class="mt-3">Confirm New Password</label>
                    <input type="password" name="passwordConfirmation" formControlName="passwordConfirmation" (keydown.space)="$event.preventDefault();" required>

                    <button type="submit" value="Submit" [disabled]="!resetPasswordForm.valid">Submit</button>

                </form>
            </div>

        </div>
    </div>
</div>